import { IGuid } from './ITypes';
import { Repository } from '../fetch';
import { objectToJsonAuditComment, PropertyToValueDict } from '../changesToChangeLog';

export enum SubscriptionType {
    Free = -1,        // expiresOn = null
    Licensed = 0,     // expiresOn & licensedSubscription defined
    Trial = 1
}

export interface ISubscription {
    Id: IGuid;
    OrganizationId: IGuid;
    Product: number;
    CreatedOn: string;
    Type: SubscriptionType;
    ExpiresOn?: string | null;
    Total?: number | null;
    Used?: number | null;   // readonly
    Free?: number | null;

    AuditComment?: string | null;
    RowVersion?: string | null;

    // Forms PowerPages only (Product === FORMS_POWERPAGES_PRODUCT). Carried by the
    // shared Subscription form and posted to the /management/forms-license endpoint.
    FormsUrl?: string | null;
    FormsLicenseType?: number | null;
}


const nextMonth = (): Date => {
    const now = new Date();
    now.setMonth(now.getMonth() + 1);
    return now;
}

export const DefaultSubscription: ISubscription = {
    Id: '',
    OrganizationId: '',
    Product: 1,
    CreatedOn: new Date().toISOString(),  //format '2020-02-26T19:16:24.023Z'
    ExpiresOn: nextMonth().toISOString(),
    Type: SubscriptionType.Trial
}

export type ISubscriptions = Array<ISubscription | null>;
export const UnlimitedTotal = 2147483647;

const propertyToValue: PropertyToValueDict = {
    Id: () => undefined,
    OrganizationId: () => undefined,
    Organization: () => undefined,
    Product: () => undefined,
    RowVersion: () => undefined,
    Type: (value: any) => Repository.LicenseTypes[value],
    ExpiresOn: (value: any) => value,
}

export const buildSubscriptionAuditComment = (changes: any, oldValues: any, name: string): string | null =>
    objectToJsonAuditComment(changes, oldValues, propertyToValue, "S", name);
